export default class UserEntry {
    // #region Properties
    userId = "";
    userName = "";
    displayName = "";
    subTitle = "";
    firstName;
    lastName;
    initials;
    avatarMedia;
    accountID;
    accountName;
    // #endregion
    // #region Properties
    get fullName() {
        if (this.displayName) {
            return this.displayName;
        }
        if (!this.firstName) {
            return "";
        }
        if (!this.lastName) {
            return "";
        }
        return this.firstName + " " + this.lastName;
    }
    // #endregion
    // #region Constructor
    constructor(init) {
        Object.assign(this, init);
    }
}
